import useAdminBilling from '~/routes/subscribe/$subscriberId/_components/v2/hooks/useAdminBilling';

import { AdminBillingContext, type AdminBillingContextType } from './AdminBillingContext';

type Props = {
  isLoggedIn: boolean;
  groupSubscriptionsEnabled: boolean;
  subscriberId: string;
  children: React.ReactNode;
};

/**
 * Owns the admin / group billing fan-out on the Billing tab. Self-calls `useAdminBilling`
 * (gated on the same Flipper flag as the Group subscriptions tab) and exposes the plans +
 * loading state via context. Renders no UI; the colocated `AdminBillingSection` child renders
 * from it. The subscriber's own billing lives in `BillingProvider` and stays out.
 */
export const AdminBillingProvider = ({ isLoggedIn, groupSubscriptionsEnabled, subscriberId, children }: Props) => {
  // Fan-out loader hits /group_subscriptions/:id/billing per group.
  const { data: adminBillingPlans, isLoading: isLoadingAdminBilling } = useAdminBilling({
    enabled: isLoggedIn && groupSubscriptionsEnabled,
    subscriberId,
  });

  const value: AdminBillingContextType = {
    adminBillingPlans,
    isLoadingAdminBilling,
  };

  return <AdminBillingContext.Provider value={value}>{children}</AdminBillingContext.Provider>;
};
